<div class="add-performance-modal-backdrop" (click)="onBackdropClick($event)">
  <div class="add-performance-modal" role="dialog" aria-modal="true" aria-labelledby="editPerformanceTitle">
    <div class="add-performance-header">
      <div>
        <h2 id="editPerformanceTitle" class="add-performance-title">Edit performance</h2>
        <div class="add-performance-sub">Update the performance description</div>
      </div>
      <button type="button" class="add-performance-close" aria-label="Close" (click)="cancel()">×</button>
    </div>

    <div class="add-performance-content">
      <tm1-banner *ngIf="saveError" appearance="error" class="add-performance-banner">{{ saveError }}</tm1-banner>

      <div class="add-performance-form">
        <div class="field-group">
          <label for="editPerformanceDescription" class="field-label">Description</label>
          <input
            id="editPerformanceDescription"
            class="form-control"
            type="text"
            placeholder="e.g. Rd 9: Brisbane Lions v Carlton"
            [(ngModel)]="description"
            name="editPerformanceDescription" />
        </div>

        <div class="field-row">
          <div class="field-group">
            <label class="field-label">Date</label>
            <input class="form-control" type="text" [value]="displayDate" disabled />
          </div>

          <div class="field-group">
            <label class="field-label">Start time</label>
            <input class="form-control" type="text" [value]="displayTime" disabled />
          </div>
        </div>

        <tm1-typography type="body-s" class="tz-note">
          Date and time can't be changed once a performance is created. Delete and re-create the performance if the schedule changes.
        </tm1-typography>

        <tm1-banner *ngIf="validationError" appearance="warning" class="add-performance-banner">
          {{ validationError }}
        </tm1-banner>

        <div class="add-performance-actions">
          <button type="button" class="btn-modal btn-modal--ghost" [disabled]="saving" (click)="cancel()">Cancel</button>
          <button type="button" class="btn-modal btn-modal--primary" [disabled]="saving" (click)="save()">
            {{ saving ? 'Saving…' : 'Save changes' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
